/* tslint:disable */
/* eslint-disable */
/**
 * ProjectOne API
 * API for Classical Conversations content and communities.  # Service URLs In local dev: - [The **local backend**](http://0.0.0.0:8080/) defaults to running on port 8080. - [The **local frontend**](http://0.0.0.0:3000/) defaults to running on port 3000.  In the DEV environment: - [The **DEV backend**](https://dev-ccp1-api.classicaltesting.net/) runs at https://dev-ccp1-api.classicaltesting.net/. - [The **DEV frontend**](https://dev-ccp1.classicaltesting.net/) runs at https://dev-ccp1.classicaltesting.net/.  The TEST environment is similar, but with `test-` instead of `dev-`.
 *
 * The version of the OpenAPI document: ad7f31f2 (Tue Mar  3 17:44:55 UTC 2026)
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 * @interface ActorFilterOption
 */
export interface ActorFilterOption {
  /**
   * Unique identifier of the actor
   * @type number
   * @memberof ActorFilterOption
   */
  actorKey: number
  /**
   * The name of the actor
   * @type string
   * @memberof ActorFilterOption
   */
  name: string
  /**
   * The director's role name
   * @type string
   * @memberof ActorFilterOption
   */
  roleName: string
  /**
   * The date in which the actor is valid from in date-time format.
   * @type Date
   * @memberof ActorFilterOption
   */
  validFrom: Date
  /**
   * The date in which the actor becomes invalid on and after in date-time format.
   * @type Date
   * @memberof ActorFilterOption
   */
  validTo: Date
}

export function ActorFilterOptionFromJSON(json: any): ActorFilterOption {
  return ActorFilterOptionFromJSONTyped(json, false)
}

export function ActorFilterOptionFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): ActorFilterOption {
  if (json === undefined || json === null) {
    return json
  }
  return {
    actorKey: json['actorKey'],
    name: json['name'],
    roleName: json['roleName'],
    validFrom: new Date(json['validFrom']),
    validTo: new Date(json['validTo']),
  }
}

export function ActorFilterOptionToJSON(value?: ActorFilterOption | null): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    actorKey: value.actorKey,
    name: value.name,
    roleName: value.roleName,
    validFrom: value.validFrom.toISOString(),
    validTo: value.validTo.toISOString(),
  }
}
